<template>
  <div>
    <v-list-item class="pl-0" v-if="customer">
      <v-list-item-action class="pa-0 mr-3">
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn @click="$emit('send_all')" v-on="on" color="success" icon large><v-icon>mdi-check-all</v-icon></v-btn>
          </template>
          <span>Approve all</span>
        </v-tooltip>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title class="text-decoration-underline title">{{customer.primary_name.name}}</v-list-item-title>
        <v-list-item-subtitle>{{customer.contract.contract_type.desc}}</v-list-item-subtitle>
      </v-list-item-content>
      <template v-if="customer.billing">
        <v-list-item-content>
          <v-list-item-title>Bill Overdue</v-list-item-title>
          <v-list-item-subtitle>${{customer.billing.bill_overdue}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>AR Current</v-list-item-title>
          <v-list-item-subtitle>${{customer.billing.ar_current}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>AR Total</v-list-item-title>
          <v-list-item-subtitle>${{customer.billing.ar_total}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>AR Date</v-list-item-title>
          <v-list-item-subtitle>{{customer.billing.ar_date ? customer.billing.ar_date : "N/A"}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>Income Current</v-list-item-title>
          <v-list-item-subtitle>${{customer.billing.income_current}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>Income Date</v-list-item-title>
          <v-list-item-subtitle>{{customer.billing.income_date ? customer.billing.income_date : "N/A"}}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-list-item>
    <v-divider class="info"></v-divider>
  </div>
</template>

<script>
export default {
  name: "SampleGroupCustomerInfo",
  props:{
    customer:{
      required: false,
      type: Object
    },
  }
}
</script>

<style scoped>

</style>